import {BlockContainer} from "BaseComponents/Wrappers";
import React, {useState, useRef, useEffect} from "react";
import {H2} from "BaseComponents/Text";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {PrimaryButton, ButtonText} from "Buttons";
import {useGlobal} from "reactn";
import {GetTextColor} from "Helpers/ColorHelper";

export const LinkBlock = (model) => {
    const {Heading, Links, BackgroundColor} = model;
    const {textColor} = GetTextColor(BackgroundColor);

    return (
        <LinkBlockWrapper>
            <LinkHeader backgroundColor={BackgroundColor} textColor={textColor} align="center">{Heading}</LinkHeader>

            <LinkListWrapper>
                {Links.map((link, i) => {
                    const {Name, Type, Url, Target} = link;
                    return (
                        <LinkWrapper key={i}>
                            <Link
                                color={textColor}
                                key={i}
                                target={Target}
                                widthsmall="160px"
                                href={Url}
                                margin="15px 0 15px 15px"
                                minHeightSmall="45px"
                                minHeight="40px"
                                smallmargin="5px 1rem"
                                wide
                                widthsmall="100%"
                            >
                                <span>{Name}</span>
                                {Type == 2 ? (
                                    <Icon className="icon-link-ext"></Icon>
                                ) : (
                                    <Icon className="icon-right-arrow"></Icon>
                                )}
                            </Link>
                        </LinkWrapper>
                    );
                })}
            </LinkListWrapper>
        </LinkBlockWrapper>
    );
};

const LinkBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px 10px;
  border: solid 1px #808080;

  ${media.lessThan(breakpoints.mobile)`
    
    margin: 10px 0;`}
`;

const Link = styled.a`
  display: inline-flex;
  align-items: center;

  span {
    transition: 0.2s ease;

    border-bottom: 2px solid transparent;
  }

  &:hover {
    span {
      transition: 0.2s ease;
      border-color: inherit;
    }
  }

  i {
    margin-left: 8px;
  }
`;
const LinkHeader = styled.h2`
  padding: 15px;
  background-color: ${({theme, backgroundColor}) => backgroundColor ? `#${backgroundColor}` : theme.colors.bg3};
  color: ${({textColor}) => textColor ? textColor : '#fff'};
  font-size: 20px;
  margin: 0;
  font-weight: 500;
  line-height: normal;
`;

const LinkWrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #f0f0f0;

  &:nth-of-type(2n) {
    background-color: white;
  }
`;
export const Icon = styled.i`
  margin-right: 10px;
`;

export const LinkListWrapper = styled.div`
  a[href$=".pdf"]:before {
    display: none;
  }

  transition: 0.3s ease;
  flex-direction: column;
  display: flex;
  height: 100%;
  width: 100%;
  max-width: ${({width}) => (width ? width : "")};
  align-items: center;
  transition-delay: 0.2s;
  display: flex;

  background-color: ${({bgColor}) => (bgColor ? bgColor : "transparent")};
`;
